export const FETCH_VOICE_REQUIREMENTS_FAILURE = "FETCH_VOICE_REQUIREMENTS_FAILURE";
export const FETCH_VOICE_REQUIREMENTS_REQUEST = "FETCH_VOICE_REQUIREMENTS_REQUEST";
export const FETCH_VOICE_REQUIREMENTS_SUCCESS = "FETCH_VOICE_REQUIREMENTS_SUCCESS";
